import React from 'react';
import { Table } from 'semantic-ui-react';
import PropTypes from 'prop-types';

export const PhoneInventoryRow = props => {
    const phone = props.phone;
    const isAssignedToBusiness = phone.assignment_status === 'assigned' || phone.assignment_sid;
    const isAssignedToSms = phone.is_assigned; // A2P campaign assignment
    const phoneId = phone.id || phone.phone_number_sid || phone.phone_sid;
    const hasCampaign = props.campaignData?.id;

    const getStatus = () => {
        if (isAssignedToBusiness) {
            return 'Assigned';
        }
        return 'Available';
    };

    const getType = () => {
        const type = phone.number_type || phone.type || 'local';
        //reviurn voip to VoIP
        if (type.toLowerCase() === 'voip') {
            return 'VoIP';
        }
        return type;
    };

    // Voice capability: based on business profile assignment + number_type direction
    const getVoiceAssignment = () => {
        if (!isAssignedToBusiness) return 'Unassigned';
        const direction = (phone.number_type || '').toLowerCase();
        if (direction === 'inbound') return 'Inbound';
        if (direction === 'outbound') return 'Outbound';
        return 'Both';
    };

    // SMS capability: based on A2P campaign assignment
    const getSmsAssignment = () => {
        if (!isAssignedToSms) return 'None';
        const direction = (phone.number_type || '').toLowerCase();
        if (direction === 'inbound') return 'Inbound';
        if (direction === 'outbound') return 'Outbound';
        return 'Both';
    };

    const getAssignment = () => {
        if (isAssignedToBusiness && isAssignedToSms) return 'Business + SMS';
        if (isAssignedToBusiness) return 'Business Profile';
        if (isAssignedToSms) return 'SMS Campaign';
        return 'Not Assigned';
    };

    const getActionButtons = () => {
        const buttons = [];

        // Business Profile Assignment/Unassignment Button
        if (isAssignedToBusiness) {
            buttons.push(
                <button
                    key="unassign-business"
                    className="btn linear-gradient zy-save-btn"
                    onClick={() => !props.loading && props.onUnassignPhone(phone)}
                    disabled={props.loading}
                >
                    Unassign from Business
                </button>
            );

            // SMS Assignment/Unassignment Button (only if assigned to business profile)
            if (hasCampaign) {
                if (isAssignedToSms) {
                    buttons.push(
                        <button
                            key="unassign-sms"
                            className="btn linear-gradient zy-save-btn"
                            onClick={() => !props.loading && props.onUnassignPhoneFromSms(phone)}
                            disabled={props.loading}
                        >
                            Unassign from SMS
                        </button>
                    );
                } else {
                    buttons.push(
                        <button
                            key="assign-sms"
                            className="btn linear-gradient zy-save-btn"
                            onClick={() => !props.loading && props.onAssignPhoneToSms(phone)}
                            disabled={props.loading}
                        >
                            Assign to SMS
                        </button>
                    );
                }
            }
        } else {
            // Not assigned to business - show assign to business button only
            buttons.push(
                <button
                    key="assign-business"
                    className="btn linear-gradient zy-save-btn"
                    onClick={() => !props.loading && props.onAssignPhone(phone)}
                    disabled={props.loading}
                >
                    Assign to Business
                </button>
            );
        }

        return buttons;
    };

    return (
        <Table.Row className={`phone-inventory-row ${props.phone.checked ? 'row-selected' : ''}`}>
            <Table.Cell style={{ display: 'none' }}></Table.Cell>
            <Table.Cell style={{ whiteSpace: "nowrap" }}>
                <div className="phone-number-main">{phone.phone_number || phone.twilio_phone || 'N/A'}</div>
               
            </Table.Cell>
            <Table.Cell style={{ textTransform: "capitalize" }}>
                {getType()}
            </Table.Cell>
            <Table.Cell>
                {getStatus()}
            </Table.Cell>
            <Table.Cell>
                {getVoiceAssignment()}
            </Table.Cell>
            <Table.Cell>
                {getSmsAssignment()}
            </Table.Cell>
            <Table.Cell>
                {getAssignment()}
            </Table.Cell>
            <Table.Cell>
                <span style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
                    {getActionButtons()}
                </span>
            </Table.Cell>
        </Table.Row>
    );
};

PhoneInventoryRow.propTypes = {
    phone: PropTypes.object.isRequired,
    onCheckboxChange: PropTypes.func.isRequired,
    onAssignPhone: PropTypes.func.isRequired,
    onUnassignPhone: PropTypes.func.isRequired,
    onAssignPhoneToSms: PropTypes.func.isRequired,
    onUnassignPhoneFromSms: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    campaignData: PropTypes.object,
};
